import ActionTypes from "../actions/action-types.js";

const openFilters = function (currentOpenFilters = [], action) {
  const newOpenFilters = [...currentOpenFilters];

  if (action.type !== ActionTypes.TOGGLE_OPEN_FILTERS) {
    return newOpenFilters;
  }

  if (action.payload.open) {
    newOpenFilters.push(action.payload.filterGroupKey);
    return Array.from(new Set(newOpenFilters));
  }

  return newOpenFilters.filter(f => f !== action.payload.filterGroupKey);
};

const types = [ActionTypes.TOGGLE_OPEN_FILTERS];

const fn = function (state, action) {
  return {
    ...state,
    openFilters: openFilters(state.openFilters, action),
  };
};

export default {
  types: types,
  fn: fn,
};
